import state from '~store/modules/documents/state'
import actions from '~store/modules/documents/actions'

export default {
  state,
  actions
}
